"use client";

import { useEffect, useState } from "react";

import { profileAvatarUrl } from "@/lib/profile/media";
import { cn, getInitials } from "@/lib/utils";

type UserAvatarProps = {
  name: string;
  src?: string | null;
  path?: string | null;
  className?: string;
};

export function UserAvatar({ name, src, path, className }: UserAvatarProps) {
  const url = src || profileAvatarUrl(path);
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
  }, [url]);

  return (
    <div
      className={cn(
        "flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary/10 text-xs font-semibold text-primary",
        className,
      )}
      aria-hidden="true"
    >
      {url && !broken ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={url}
          alt=""
          className="size-full object-cover"
          onError={() => setBroken(true)}
        />
      ) : (
        getInitials(name)
      )}
    </div>
  );
}
